import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule }  from '@angular/http';
import { FormsModule } from '@angular/forms';
import { TelcoComponent } from './telco.component';
import { TelcoService } from '../shared/services/telco.service';
import { MatTableModule, MatPaginatorModule, MatSortModule, MatSnackBarModule, MatProgressBarModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatProgressBarModule
  ],
  declarations: [
    TelcoComponent
  ],
  exports: [
    TelcoComponent
  ],
  providers: [
    TelcoService
  ]
})
export class TelcoModule { }



// WEBPACK FOOTER //
// ./src/app/telco/telco.module.ts